import { InputBaseParams } from "../../forms/Form";
import TextArea from "../../forms/inputs/TextArea";

const SettingsTextArea = ({
  name,
  label,
  placeholder,
  rows,
  rules,
  className
}: InputBaseParams & {
  label?: string;
  placeholder?: string;
  rows?: number;
  className?: string;
}) => (
  <div className={className}>
    {label && (
      <p className="mb-2 leading-[150%]">
        {label + (rules?.required ? " *" : "")}
      </p>
    )}
    <TextArea
      name={name}
      placeholder={placeholder}
      rows={rows}
      rules={rules}
      className="mb-4 w-full rounded border-[1px] border-ctb-grey-300 px-3 py-2 text-[13px]"
      errorClassName="!border-red-500"
    />
  </div>
);

export default SettingsTextArea;
